// log-icon-selected.png
import { useContext, useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import moment from 'moment'
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import { projectContext, loadingContext, unfolder, urlValue } from '../lib'
import SideBar from '../components/SideBar'

import { customModal } from '../styles/customModal'
import '../styles/report.scss'
import '../styles/general.scss'
import TitleBar from "../components/TitleBar";
import { useParams } from 'react-router-dom'
export default function ReportLogs(props) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [clients, setClients] = useState([])
  const [logs, setLogs] = useState([]);
  const [screen, setScreen] = useState(1)
  const params = useParams();
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const category = useRef();
  const from = useRef();
  const to = useRef();

  //studio/projects/logs

  const getReports = async (column, orderBy) => {
    
    try {
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      const result = await axios.post(`${urlValue}/studio/project/logs/all`, {
        order: orderBy,
        column: column,
        "project_id": selectedProject.id,
        "user_id": '',
        "user_name": "",
        "categoria": category.current.value,
        "fechaInicial": moment(new Date(from.current.value)).format('YYYY-MM-DD') + ' 00:00:00',
        "fechaFinal": moment(new Date(to.current.value)).format('YYYY-MM-DD') + ' 23:59:59'
      },
        {
          headers: {
            'user': id,
            'Content-Type': 'application/json',
            'access-token': token,
            'projectid': selectedProject.id,
          },
        });

      if (result.status === 200) {
        setLogs(result.data)
      }

    } catch (error) {

    }

  }
  useEffect(() => {

    from.current.value = moment(new Date()).subtract('month', 1).format('YYYY-MM-DD');
    to.current.value = moment(new Date()).format('YYYY-MM-DD');
    getReports('id', 'asc');
  }, [])

  const onChange = async (e) => {
    getReports('id', 'asc');
  }

  const orderBy = async (column, e) => {

    if (e.target.classList.contains('rotar')) {
      getReports(column, 'asc');
    } else {
      getReports(column, 'desc');
    }
    e.target.classList.toggle("rotar")
    //setLogs(log)
  }
  return (
    <>
      <section className="container-answers general-container" id="container">
        <SideBar active={'Logs'} />
        <div className="row_primary  ">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="con_header">
            <div className="header">
              <div className="title">
                <div className="intents">
                  <div className="project-name-container">
                    <div className="icon"></div>
                    <h2>{selectedProject.name}</h2>
                  </div>
                  <div className="separator">-</div>
                  <div>
                    <h1>Changes Logs</h1>
                  </div>

                </div>

              </div>
            </div>

          </div>


          <div className="container-info" style={{ marginTop: -50 }}>

            <div className="body-container">

              <div className='mt-5 w-full flex flex-col items-start  justify-start ' >
                <div className=' flex flex-row items-center  w-full '>
                  <div className=' flex flex-row items-center  '>
                    <div className='mr-1 label-report'>Category: </div>
                    <select ref={category} onChange={onChange} id="style" className="w-100 input-data   select-nesting"
                      style={{ fontSize: 16, border: '1px solid #e3e3e3', borderRadius: 25, minWidth: 220, padding: 8 }}>
                      <option value="">All</option>
                      <option value="Project">Project</option>
                      <option value="Answer">Answer</option>
                      <option value="Intent">Intent</option>
                      <option value="Setting">Setting</option>
                    </select>
                  </div>

                  <div className='  flex flex-row items-center ml-5 '>
                    <div className='mr-2 label-report'>From: </div>
                    <input id="from" ref={from} onChange={onChange} type='date' className="input-nesting input-data  input-date-nesting" />
                  </div>
                  <div className='  flex flex-row items-center ml-5 ' >
                    <div className='mr-2 label-report'>To: </div>
                    <input ref={to} onChange={onChange} type='date' className="input-nesting input-data  input-date-nesting" />
                  </div>
                  <div style={{ flex: 1 }}></div>
                  <div className="ml-3 input-data p-1 bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray', }}>
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={event => {
                        setSearch(event.target.value)
                      }}
                      className="ml-3 "
                      style={{ border: 'none', fontSize: 18 }}
                    />
                    <img src="/icons/search.svg" style={{ width: 18, marginRight: 10 }} />
                  </div>
                </div>
                <table className="table-reports mt-1">
                  <thead>
                    <tr>
                      <th> <div className='icos-th'><span>ID</span> <img onClick={(e) => { orderBy('id', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>Category</span> <img onClick={(e) => { orderBy('categoria', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>Date</span> <img onClick={(e) => { orderBy('fecha', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>User-Studio</span> <img onClick={(e) => { orderBy('user_name', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>Description</span> <img onClick={(e) => { orderBy('descripcion', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.filter((x)=>(x.user_name.includes(search) || x.id.toString().includes(search))).map((item, index) => (
                      <tr>
                        <td>{item.id}</td>
                        <td>{item.categoria}</td>
                        <td>{moment(item.fecha).format('YYYY-MM-DD')}</td>
                        <td>{item.user_name}</td>
                        <td>{item.descripcion}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* <iframe src="https://datastudio.google.com/reporting/53dfbc18-5b2d-486c-a36f-f461e3a880d7/page/kK78C?params=%7B%22df46%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580120%22%7D" height="400px" width="600px"></iframe> */}



      </section>

    </>
  )
}
